import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "w-full mt-4 overflow-y-auto overflow-x-hidden",
  style: {"grid-area":"table"}
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"hidden md:grid lg:grid-cols-12 md:grid-cols-6 gap-2 w-full items-center py-2 border-b font-semibold text-gray-700 text-xs md:text-sm\"><div class=\"lg:col-span-4 md:col-span-4\"><p class=\"text-left\">Pessoa/Grupo com Acesso</p></div><div class=\"lg:col-span-4 md:col-span-4\"><p class=\"truncate\">E-mail</p></div><div class=\"lg:col-span-4 md:col-span-4\"><p>Nível de acesso</p></div></div>", 1)

import TableAccessManager from '@/components/designSystem/Table/TableAccessManager.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'access.manager.tab',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(TableAccessManager)
  ]))
}
}

})